import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../../utils/API/fetchBaseQuery";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";
import { transformRequest } from "../../utils/API/requestMiddleware";

// Create projectStatus API
const projectSynergyAPI = createApi({
    reducerPath: "projectSynergyAPI",
    baseQuery: customFetchBase,
    endpoints: (builder) => ({

        // Query to get all Synergy Types list
        getAllSynergyTypes: builder.query({
            query: () => ({
                url: `/ProjectSynergy/GetAllSynergyTypes`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        // Query to get all Synergy Priority list
        getAllSynergyPriority: builder.query({
            query: () => ({
                url: `/ProjectSynergy/GetAllSynergyPriority`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        // Query to get all Synergy Statuse list
        getAllSynergyStatuses: builder.query({
            query: () => ({
                url: `/ProjectSynergy/GetAllSynergyStatuses`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAllProjectSynergyList: builder.mutation({
            query: (data) => ({
                url: `/ProjectSynergy/GetProjectSynergyList`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        // Query to get all Synergy Deatils By Project ID
        getAllSynergyByProjectId: builder.query({
            query: (projectId) => ({
                url: `ProjectSynergy/GetAllSynergyByProjectId/?ProjectId=${projectId}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        // Query to get all Synergy Deatils By ID
        getSynergyDetailsBySynergyId: builder.query({
            query: (SynergyID) => ({
                url: `ProjectSynergy/GetSynergyDetailsBySynergyId?SynergyID=${Number(SynergyID)}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        // Query to get all Synergy comments By Synergy ID
        getAllSynergyCommentBySynergyId: builder.query({
            query: (SynergyID) => ({
                url: `/ProjectSynergy/GetAllSynergyCommentBySynergyId?SynergyID=${Number(SynergyID)}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        // Mutation to get all Synergy comments
        addSynergyComment: builder.mutation({
            query: (data) => ({
                url: `/ProjectSynergy/AddSynergyComment`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        deleteSynergyComment: builder.mutation({
            query: (commentID) => ({
                url: `/ProjectSynergy/DeleteSynergyComment?CommentID=${commentID}`,
                method: 'DELETE',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        addSynergyAttachment: builder.mutation({
            query: (data) => ({
                url: `/ProjectSynergy/AddSynergyAttachment`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        addProjectSynergy: builder.mutation({
            query: (data) => ({
                url: `/ProjectSynergy/AddProjectSynergy`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        deleteSynergyAttachmentById: builder.mutation({
            query: (attachmentID) => ({
                url: `/ProjectSynergy/DeleteSynergyAttachmentById?attachmentID=${attachmentID}`,
                method: 'DELETE',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        updateProjectSynergy: builder.mutation({
            query: (data) => ({
                url: `/ProjectSynergy/UpdateProjectSynergy`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        updateSynergyComment: builder.mutation({
            query: (data) => ({
                url: `/ProjectSynergy/UpdateSynergyComment`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getSynergyAttachmentListBySynergyId: builder.query({
            query: (synergyId) => ({
                url: `/ProjectSynergy/GetSynergyAttachmentListBySynergyId?synergyId=${Number(synergyId)}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getSynergyTaskBySynergyId: builder.query({
            query: (SynergyId) => ({
                url: `/ProjectSynergy/GetSynergyTaskBySynergyId?SynergyId=${SynergyId}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
      
        getAllUnAssignSynergyTask: builder.mutation({
            query: (data) => ({
                url: `/ProjectSynergy/GetAllUnAssignSynergyTask`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        addAttachedSynergyTasks: builder.mutation({
            query: (data) => ({
                url: `/ProjectSynergy/AddAttachedSynergyTasks`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAllProjectSynergyStatusByTypeId: builder.query({
            query: ({ IncludeChangeRequest, IncludeUserStory }) => ({
                url: `/ProjectSynergy/GetAllProjectSynergyStatusByTypeId?IncludeChangeRequest=${IncludeChangeRequest}&IncludeUserStory=${IncludeUserStory}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        removeSynergyTaskByTaskId: builder.mutation({
            query: (TaskId) => ({
                url: `/ProjectSynergy/RemoveSynergyTaskByTaskId/?taskId=${TaskId}`,
                method: 'DELETE',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    })
})

// Extract hooks for easy access to various API requests 
export const {
    useLazyGetAllSynergyTypesQuery,
    useLazyGetAllSynergyPriorityQuery,
    useLazyGetAllSynergyStatusesQuery,
    useGetAllProjectSynergyListMutation,
    useLazyGetAllSynergyByProjectIdQuery,
    useLazyGetSynergyDetailsBySynergyIdQuery,
    useLazyGetAllSynergyCommentBySynergyIdQuery,
    useAddProjectSynergyMutation,
    useDeleteSynergyCommentMutation,
    useAddSynergyCommentMutation,
    useAddSynergyAttachmentMutation,
    useDeleteSynergyAttachmentByIdMutation,
    useUpdateSynergyCommentMutation,
    useUpdateProjectSynergyMutation,
    useLazyGetSynergyTaskBySynergyIdQuery,
    useGetAllUnAssignSynergyTaskMutation,
    useAddAttachedSynergyTasksMutation,
    useLazyGetAllProjectSynergyStatusByTypeIdQuery,
    useLazyGetSynergyAttachmentListBySynergyIdQuery,
    useRemoveSynergyTaskByTaskIdMutation
} = projectSynergyAPI;

export default projectSynergyAPI;